import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import {
  useSaveDesignationsMutation,
  useGetDepartmentsQuery,
} from '../../services/settings.service';

const { Option } = Select;

const DesignationModal = ({ visible, designation, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [saveDesignation, { isLoading }] = useSaveDesignationsMutation();
  const { data: departmentsData } = useGetDepartmentsQuery();

  const departments = departmentsData?.data || [];

  useEffect(() => {
    if (visible) {
      if (designation) {
        // Editing existing designation
        form.setFieldsValue({
          name: designation.name,
          departmentId: designation.departmentId || null,
        });
      } else {
        // Adding new designation - set defaults
        form.setFieldsValue({
          name: '',
          departmentId: null,
        });
      }
    }
  }, [visible, designation, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const payload = {
        ...values,
        ...(designation?.id && { id: designation.id }),
      };

      await saveDesignation(payload).unwrap();

      message.success(
        `Designation ${designation ? 'updated' : 'created'} successfully`
      );

      form.resetFields();
      onSuccess();
    } catch (error) {
      if (error?.data?.message) {
        message.error(error.data.message);
      } else if (error?.errorFields) {
        message.error('Please fill in all required fields');
      } else {
        message.error('Failed to save designation');
      }
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={designation ? 'Edit Designation' : 'Add Designation'}
      open={visible}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={isLoading}
      width={600}
      okText={designation ? 'Update' : 'Create'}
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item
          name="name"
          label="Designation Name"
          rules={[
            { required: true, message: 'Please enter designation name' },
            { min: 2, message: 'Name must be at least 2 characters' },
            { max: 100, message: 'Name cannot exceed 100 characters' },
          ]}
        >
          <Input
            placeholder="e.g., Software Engineer, Manager, Team Lead"
            size="large"
          />
        </Form.Item>

        <Form.Item
          name="departmentId"
          label="Department"
          tooltip="Optionally assign this designation to a specific department"
        >
          <Select
            placeholder="Select department (optional)"
            size="large"
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {departments.map((dept) => (
              <Option key={dept.id} value={dept.id}>
                {dept.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DesignationModal;
